import { CarMakesResponse } from 'types';

export const slugToModel = ({ modelSlug, carMakes }: { modelSlug: string; carMakes: CarMakesResponse }) =>
  Object.values(carMakes)
    .flat()
    .find((cm) => cm.slug === modelSlug)?.model;
